import { createAction, props } from '@ngrx/store';

import { ErrorResponse } from '#types/core';
import { CustomerDetailResponseBody, CustomerLookupResponseBody } from '#types/customer';
import { Filters, Sorts } from '#types/grid';
import { ListOfValuesResponse, MultipleListOfValuesResponse } from '#types/list';

//
// customer / request lists
//

export const RequestLists = createAction('[Customer] - Request Lists');

//
// customer lists
//
export const RequestCustomerLists = createAction('[Customer.List] - Request Customer Lists');
export const RequestCustomerListsSuccess = createAction(
  '[Customer.List] - Request Customer Lists Success',
  props<{ lists: MultipleListOfValuesResponse }>()
);
export const RequestCustomerListsFailure = createAction(
  '[Customer.List] - Request Customer Lists Failure',
  props<{ error: ErrorResponse }>()
);

//
// customer / dictionary field list
//

export const RequestCustomerDictionaryFieldList = createAction(
  '[Customer.List] - Request Customer Dictionary Field List',
  props<{ custid: string }>()
);
export const RequestCustomerDictionaryFieldListSuccess = createAction(
  '[Customer.List] - Request Customer Dictionary Field List Success',
  props<{ custid: string; list: ListOfValuesResponse }>()
);
export const RequestCustomerDictionaryFieldListFailure = createAction(
  '[Customer.List] - Request Customer Dictionary Field List Failure',
  props<{ error: ErrorResponse }>()
);

//
// customer / item uom list
//

export const RequestCustomerItemUomList = createAction(
  '[Customer.List] - Request Customer Item UOM List',
  props<{ custid: string; item: string }>()
);
export const RequestCustomerItemUomListSuccess = createAction(
  '[Customer.List] - Request Customer Item UOM List Success',
  props<{ custid: string; item: string; list: ListOfValuesResponse }>()
);
export const RequestCustomerItemUomListFailure = createAction(
  '[Customer.List] - Request Customer Item UOM List Failure',
  props<{ error: ErrorResponse }>()
);

//
// customer / lookup dialog
//

export const CustomerLookupDialogRequestData = createAction('[Customer.Lookup.Dialog] - Grid Request Data', props<{ id: string }>());
export const CustomerLookupDialogRequestDataWithParameters = createAction(
  '[Customer.Lookup.Dialog] - Grid Request Data With Parameters',
  props<{ id: string; filters: Filters; page: number; first: number; rows: number; sorts: Sorts }>()
);
export const CustomerLookupDialogRequestDataWithFilters = createAction(
  '[Customer.Lookup.Dialog] - Grid Request Data With Filters',
  props<{ id: string; filters: Filters }>()
);
export const CustomerLookupDialogRequestDataSuccess = createAction(
  '[Customer.Lookup.Dialog] - Grid Request Data Success',
  props<{ id: string; data: CustomerLookupResponseBody }>()
);
export const CustomerLookupDialogRequestDataFailure = createAction(
  '[Customer.Lookup.Dialog] - Grid Request Data Failure',
  props<{ id: string }>()
);

//
// customer / detail
//

export const DetailRequestData = createAction('[Customer.Detail] - Grid Request Data', props<{ custid: string }>());
export const DetailRequestDataSuccess = createAction(
  '[Customer.Detail] - Grid Request Data Success',
  props<{ data: CustomerDetailResponseBody }>()
);
export const DetailRequestDataFailure = createAction('[Customer.Detail] - Grid Request Data Failure');

export const DetailClearData = createAction('[Customer.Detail] - Clear Data');
